<div class="dd-faq">
    <div class="content-wrapper">
        <div class="header">
            <div class="titlePanel">
                Frequently Asked Questions
            </div>
        </div>

        <!-- About -->
        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What is DeliveryDefense <sup class="trademark in-header">TM</sup> Address Scoring?
            </mat-expansion-panel-header>
            <div class="panelBody">
                DeliveryDefense <sup class="trademark">TM</sup> Address Scoring from UPS Capital provides AI-enabled address confidence
                 scoring that leverages machine learning and enriched delivery data to predict delivery
                  outcomes before you even create a label – helping shippers make smarter, safer shipping 
                  decisions.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How does DeliveryDefense <sup class="trademark in-header">TM</sup> Address Confidence scoring work?
            </mat-expansion-panel-header>
            <div class="panelBody">
                DeliveryDefense <sup class="trademark">TM</sup>'s proprietary address confidence score looks at historical delivery 
                performance and uses powerful data models to determine the likelihood of a successful 
                delivery to its destination. See the scoring information <a id="id1" (click)="downloadPdf($event)">overview</a>. Factors considered
                 in the scoring include:
                 
                <li>Loss Frequency</li>
                <li>Returns Volume</li>
                <li>Delivery Attempts</li>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How does DeliveryDefense <sup class="trademark in-header">TM</sup> Address Confidence solution work with Parcel Pro?
            </mat-expansion-panel-header>
            <div class="panelBody">
                The Parcel Pro ship platform leverages the DeliveryDefense <sup class="trademark">TM</sup> API to generate a confidence score 
                for labels that are created on the platform. This confidence level indicates the likelihood
                 of a successful delivery to the entered destination, based on historical delivery performance                 
                 at that address. For addresses with medium or low confidence levels, Parcel Pro has recently
                  introduced the option for an alternate delivery location, empowering shippers to take action
                   on the platform to enhance confidence levels and increase the probability of a successful 
                   delivery.
            </div>
        </mat-expansion-panel>

        <!-- Plans -->
        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What is included in a DeliveryDefense <sup class="trademark in-header">TM</sup> Address Confidence subscription?
            </mat-expansion-panel-header>
            <div class="panelBody">               
                As a Parcel Pro user with DeliveryDefense <sup class="trademark">TM</sup> Address Confidence, you'll enjoy benefits including 
                confidence scoring at the point of label generation, proactive loss control, optionality to help 
                improve delivery outcomes, and integrated decisioning to streamline workflows. Other benefits 
                include access to recently searched addresses and auto-generated
                 UPS Access Point<sup style="font-size: 9px;">®</sup> locations 
                for medium to low confidence scores.
            </div>
        </mat-expansion-panel>

        <!-- <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What do I do if I don’t get a score?
            </mat-expansion-panel-header>
            <div class="panelBody">  
                If a score isn't generated, there might be address format discrepancies or there may be no results
                 available for this address in the DeliveryDefense <sup class="trademark">TM</sup> database. See helpful
                  <a  id="id2" (click)="downloadPdf($event)">tips and tricks</a> on address 
                 formatting.
            </div>
        </mat-expansion-panel>  -->

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What types of subscription plans are available?
            </mat-expansion-panel-header>
            <div class="panelBody">
                <li>Value Add Program - Complimentary</li>
                <li>High Volume Program - Plans are included free of charge based on your monthly shipped volume.</li>
                See our <a id="id3" (click)="downloadPdf($event)">subscription plans</a> for more details.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How can I qualify for a different DeliveryDefense <sup class="trademark in-header">TM</sup> plan after I sign up?
            </mat-expansion-panel-header>
            <div class="panelBody">                
                Eligibility is determined by your monthly shipping volume.
                 See our <a id="id3" (click)="downloadPdf($event)">subscription plans</a> for more details.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                Can I obtain additional scores?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Customers in need of additional scores can contact <a href="mailto:amr@parcelpro.com">amr&#64;parcelpro.com</a> for a customized program review.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                Where can I manage my DeliveryDefense <sup class="trademark in-header">TM</sup> Address Confidence subscription plan?
            </mat-expansion-panel-header>
            <div class="panelBody">
                You can manage your subscription by visiting the DeliveryDefense <sup class="trademark">TM</sup> tab in
                 the Parcel Pro shipping platform and accessing the Manage Subscription page.
            </div>
        </mat-expansion-panel>

        @if (false) {
        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                When do I get billed for my DeliveryDefense <sup class="trademark in-header">TM</sup> Address Confidence subscription?
            </mat-expansion-panel-header>
            <div class="panelBody">
                You’ll be billed at the end of your free trial for the plan you selected at sign-up.
                 After that, we will invoice your Parcel Pro account for the applicable subscription 
                 fee on a recurring monthly basis. To prevent a charge, you must cancel before the end
                  of your current term. You can cancel by visiting the Manage Subscription page under 
                  the DeliveryDefense <sup class="trademark">TM</sup> tab in the shipping platform.
            </div>
        </mat-expansion-panel>
        }

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                Will I receive a confirmation for my DeliveryDefense <sup class="trademark in-header">TM</sup> Address Confidence membership?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Upon signing up, you will receive a confirmation email containing subscription plan details and the renewal date.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                Will DeliveryDefense <sup class="trademark in-header">TM</sup> Address Confidence subscriptions automatically renew?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Yes. Your subscription will be automatically renewed on a monthly basis. Scores must be utilized by the
                end of the calendar month and will reset on the 1st of each month. You can cancel by visiting the Manage
                Subscription page under the DeliveryDefense <sup class="trademark">TM</sup> tab in the shipping platform
                or contacting customer service at 1-888-683-2300.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How do I cancel my DeliveryDefense <sup class="trademark in-header">TM</sup> Address Confidence subscription?
            </mat-expansion-panel-header>
            <div class="panelBody">
                You can cancel by visiting the Manage Subscription page under the DeliveryDefense <sup class="trademark">TM</sup> 
                tab in the shipping platform or contacting customer service at 1-888-683-2300.
            </div>
        </mat-expansion-panel>

        <!-- <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What membership benefits and functions are inaccessible during a membership in the skip next<br> month
                state?
            </mat-expansion-panel-header>
            <div class="panelBody">
                As a DeliveryDefense <sup class="trademark">TM</sup>™ Address Confidence member, you’ll enjoy benefits including the Address
                <br>Confidence Tool, auto-saved addresses, and auto-generated UPS Access Point<sup style="font-size: 9px;">®</sup> locations for lower<br>
                confidence scores.</div>
        </mat-expansion-panel> -->

        <!-- Search -->
        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                Why is my search invalid?
            </mat-expansion-panel-header>
            <div class="panelBody">
                The address must be entered into the Excel sheet file in the following format: Street, City, State Abbreviation, Zip Code. 
                If the address is not entered in this format, an error message will appear at the time of upload. 
                To reduce the risk of entering an address into the Excel sheet file incorrectly, download the suggested template. 
                Find more tips by clicking "Tips & tricks” under the search bar.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What is bulk upload?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Bulk upload allows you to upload files of addresses to receive 50 or 100 (plan-specific) address scores at the same time.
                This saves you time relative to the individual address search bar. Starting from 50 or 100?
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How does bulk upload work if I have more than 100 addresses that need scores?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Since you can only bulk upload up to 100 addresses in 1 file upload, you will need to add the remaining addresses to a separate file to then upload.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                Do I have to use the provided template to use bulk upload?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Yes, for the feature to function correctly, it is essential to download and use the template. 
                Using any other format may result in issues or errors.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How do I modify or delete an address once I upload the bulk upload file?
            </mat-expansion-panel-header>
            <div class="panelBody">
                After uploading the Excel file, simply click on "Review Addresses." 
                This will provide you with the opportunity to modify or delete any of the addresses that were uploaded.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How do I know what is causing an error when I upload a bulk upload document?
            </mat-expansion-panel-header>
            <div class="panelBody">
                To identify areas with errors after uploading a document, click "Show Errors" during the address review process.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                Is there a way to save my progress during the bulk upload process?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Progress is automatically saved. If you exit voluntarily or experience a session timeout, your progress is preserved. 
                To resume, click the file name link in the Recent Uploads table, which will show “pending” under the Import Status column.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What addresses will be deducted from my Searches Remaining count?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Any unique address that returns a score and was not recently searched (i.e. an address that is not already listed in the Recently Searched table) will be deducted from the Searches Remaining count.
            </div>
        </mat-expansion-panel>

        <!-- Score -->
        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How do I interpret an address confidence score?
            </mat-expansion-panel-header>
            <div class="panelBody">
                The score, ranging from 100 to 1,000, is determined by a machine learning model that assesses the historical delivery patterns of an address. 
                A score of 1,000 signifies a very high confidence in successful delivery.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What actions should I take when an address receives a low score?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Tailor your delivery strategy based on your risk tolerance.
                Options include requiring a signature, redirecting packages to secure locations like a UPS Access Point<sup style="font-size: 9px;">®</sup> location, adding shipping insurance, or delaying customer refunds until returned items are received.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How often are scores updated?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Scoring is updated each week and based on data for a rolling 24-month period.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                Does the scoring work for international addresses?
            </mat-expansion-panel-header>
            <div class="panelBody">
                Address Confidence scoring is currently only available for domestic US addresses.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How many deliveries are needed at an address to generate a score?
            </mat-expansion-panel-header>
            <div class="panelBody">
                An address must have a minimum of 10 shipments within the past 2 years to receive a score.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                What happens if a score is not available?
            </mat-expansion-panel-header>
            <div class="panelBody">
                If there is an insufficient amount of historical data for the address to produce a score, a message will be displayed stating this after searching the address.
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansionPanel">
            <mat-expansion-panel-header class="panelHeader">
                How are individual units within a building complex scored?
            </mat-expansion-panel-header>
            <div class="panelBody">
                The Address Confidence score currently pertains to the entire complex and does not provide individual scores at the unit level.
            </div>
        </mat-expansion-panel>
    </div>
</div>
